import { PMaxCore } from 'core';
import React, { useContext } from 'react';

const coreContext = React.createContext<PMaxCore | null>(null);

export const useCoreContext = () => useContext(coreContext);
export default coreContext;
